export enum TimePeriod {
  AM = 'AM',
  PM = 'PM',
}

export interface TimeWithPeriod {
  time: string;
  period: TimePeriod;
}
